import bindAllMethods from '../../../utils/bindAllMethods';
import IIdleService from '../../../services/IdleService/IIdleService';
import { UserActivityInterfaceType } from './types';
import { getServices } from '../../../infra/startup';

class UserActivityInterface {
  private _idleService: IIdleService;

  constructor() {
    const services = getServices();
    this._idleService = services.idleService;
    bindAllMethods(this);
  }

  public getInterface(): UserActivityInterfaceType {
    return {
      isIdle: this._idleService.isIdle
    };
  }
}

export default UserActivityInterface;
